export enum GradingStatus {
  Ungraded = 'ungraded',
  Graded = 'graded',
  PendingJob = 'pending-job',
  PendingManual = 'pending-manual',
  Failed = 'failed',
}
